// Single source of truth for Second Life Software's business/entity facts.
//
// These values feed structured data (JSON-LD) across the site so search engines
// AND large language models (ChatGPT, Perplexity, Claude, Google AI Overviews)
// can identify, trust, and cite us. Keep this accurate — entity signals like
// phone, sameAs profiles, founders and ratings are exactly what GEO relies on.
//
// NOTE: the GLOBAL Organization schema also lives (hand-written) in
// public/index.html so it prerenders into every page's <head>. If you change
// name/phone/rating/sameAs here, mirror it there too (same pattern the FAQ
// schema already follows).

export const SITE_URL = 'https://secondlifesoftware.com';

export const business = {
  name: 'Second Life Software',
  legalName: 'Second Life Software',
  url: SITE_URL,
  logo: `${SITE_URL}/images/sls-logo.png`,
  email: 'info@secondlifesoftware.com',
  telephone: '+1-770-696-3187',
  description:
    "Second Life Software turns founders' ideas into shipped products — MVP " +
    'development, custom software, AI tools, and end-to-end builds. US-based, ' +
    'built for non-technical founders. No tech background needed.',

  // Service-area business (remote-first). We serve the whole US with a focus on
  // the San Francisco Bay Area and Atlanta metros.
  areaServed: ['United States', 'San Francisco Bay Area', 'Atlanta metropolitan area'],
  serviceCities: [
    { name: 'San Francisco', region: 'CA' },
    { name: 'Atlanta', region: 'GA' },
  ],

  // TODO(user): replace with your REAL profile URLs before launch. Wrong URLs
  // in sameAs hurt entity resolution, so only ship links you can verify.
  sameAs: [
    // 'https://www.linkedin.com/company/second-life-software',
    // 'https://clutch.co/profile/second-life-software',
    // 'https://www.g2.com/products/second-life-software',
    // 'https://g.page/r/your-gbp-short-link',
    // 'https://x.com/secondlifesw',
  ],

  // From Google Business Profile. AggregateRating markup is only valid when the
  // same rating is visible on-page (see components/Reviews.js).
  rating: {
    value: '5.0',
    count: 14,
    // TODO(user): paste your Google review short-link (g.page/r/...) so the
    // on-page rating links straight to your reviews.
    reviewsUrl: '',
  },

  // TODO(user): confirm names/titles/bios. First names inferred from the team's
  // calendar accounts (katia@ / darius@secondlifesoftware.com).
  founders: [
    {
      name: 'Darius',
      jobTitle: 'Co-Founder',
      bio: 'Co-founder of Second Life Software, leading engineering and delivery for founder MVPs and custom builds.',
    },
    {
      name: 'Katia',
      jobTitle: 'Co-Founder',
      bio: 'Co-founder of Second Life Software, leading product, client strategy, and delivery.',
    },
  ],
};

// The core service lines we offer — referenced by service pages and schema.
export const services = [
  'MVP Development',
  'Custom Software Development',
  'AI App Development',
  'Web Application Development',
  'API Development',
  'Software Consulting',
];

export default business;
